export default __webpack_public_path__ + "static/media/firstCarouselImage.da825497.png";